module.exports = __webpack_public_path__ + "img/9788971995051.30edb927.jpg";